// CoverageQueryHook.jsx
import { fetchBenefitByCode, fetchCoverages } from "hooks/CoverageHook";
import { useQuery } from 'react-query';

export const useCoverageQuery = (lang) => {
    return useQuery(['benefits', lang], () => fetchCoverages(lang), {
        onError: (error) => {
            console.error("Error fetching coverages:", error);
        },
    });
};

export const useBenefitByCode = (benefitCode, lang) => {
    return useQuery(['getBenefitByCode', benefitCode, lang], () => fetchBenefitByCode(benefitCode, lang), {
        enabled: Boolean(benefitCode && lang),
        onError: (error) => {
            console.error("Error fetching coverages:", error);
        },
    });
};
